/* eslint-disable no-param-reassign */
import axios, { CancelToken, isCancel } from 'axios';

export const getNsdClaimsApiBaseUrl = () => {
  let nsdClaimsApiBaseUrl = process.env.REACT_APP_APPLICATION_CLAIMS_API;
  return nsdClaimsApiBaseUrl;
};

const addCookieTokenToRequest = config => {
  config.headers.common = {
    ...config.headers.common
  };
};

const getAPIHeader = () => {
  return {
    common: {
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY
    }
  };
};

const nsdAPIHeader = getAPIHeader();

const appInstance = axios.create({
  headers: nsdAPIHeader,
  withCredentials: true,
  baseURL: getNsdClaimsApiBaseUrl()
});

appInstance.interceptors.request.use(
  config => {
    addCookieTokenToRequest(config);
    return config;
  },
  error => Promise.reject(error)
);

export default appInstance;
export { CancelToken, isCancel };
